"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_WMODE = exports.TRANSPOET_MODE_MAP = exports.DEFAULT_ATTEMPT_TRANSPORT_MODE = exports.DEFAULT_TRANSPORT_MODE = exports.WEBSOCKET_CONFIG = void 0;
/**
 *  Websocket 重试策略配置
 *  */
var WEBSOCKET_CONFIG = {
    // websocket自身重连次数
    reconnectMaxTimes: 3,
    // 连接超时时间
    connectTimeout: 5000,
    // 重连最小延迟时间
    reconnectionDelay: 3000,
    // 重连最大延迟时间
    reconnectionDelayMax: 5000,
    randomizationFactor: 1,
    // 第N次打开房间层使用polling
    pollingReopenCount: 0,
    // socekt对象第N次重试使用polling
    pollingAttemptCount: 3,
};
exports.WEBSOCKET_CONFIG = WEBSOCKET_CONFIG;
/**
 * Websocket默认模式
 *  */
var DEFAULT_TRANSPORT_MODE = ['websocket'];
exports.DEFAULT_TRANSPORT_MODE = DEFAULT_TRANSPORT_MODE;
/**
 * Websocket重连时的切换模式
 */
var DEFAULT_ATTEMPT_TRANSPORT_MODE = ['polling', 'websocket'];
exports.DEFAULT_ATTEMPT_TRANSPORT_MODE = DEFAULT_ATTEMPT_TRANSPORT_MODE;
/**
 * Websocket支持的所有模式配置结构，后台可下发模式配置
 */
var TRANSPOET_MODE_MAP = new Map([
    ['w', DEFAULT_TRANSPORT_MODE],
    ['l', ['polling']],
    ['b', DEFAULT_ATTEMPT_TRANSPORT_MODE],
]);
exports.TRANSPOET_MODE_MAP = TRANSPOET_MODE_MAP;
/**
 * wmode默认模式
 */
var DEFAULT_WMODE = 'ww';
exports.DEFAULT_WMODE = DEFAULT_WMODE;
